// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-control {
  width: 100%;
  margin-bottom: 1.5rem;
  position: relative;
  transition: 200ms all ease-in-out;
}
.form-control .input-label-text {
  color: var(--black-1000);
  font-size: 1.125rem;
  font-weight: 500;
  line-height: 1.4;
  display: block;
  margin-bottom: 0.5rem;
}
.form-control .input-label-text .required-star {
  color: var(--dangerMain-1000);
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1;
  margin-left: 0.25rem;
  display: inline-block;
}
.form-control .input-field-box {
  display: flex;
  align-items: center;
  position: relative;
}
.form-control .input-field-box .input-field,
.form-control .input-field-box .textarea-field,
.form-control .input-field-box .select-field {
  width: 100%;
  background-color: transparent;
  border: 0;
  border-bottom: 2px solid var(--black-1000);
  font-family: "Inter", sans-serif;
  color: var(--black-1000);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.4;
  padding: 1rem 0.75rem;
  transition: 200ms all ease-in-out;
}
.form-control .input-field-box .input-field::placeholder,
.form-control .input-field-box .textarea-field::placeholder,
.form-control .input-field-box .select-field::placeholder {
  color: var(--black-750);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.4;
  opacity: 1;
}
.form-control .input-field-box .input-field::-ms-input-placeholder,
.form-control .input-field-box .textarea-field::-ms-input-placeholder,
.form-control .input-field-box .select-field::-ms-input-placeholder {
  color: var(--black-750);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.4;
  opacity: 1;
}
.form-control .input-field-box .select-field {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  transition: 200ms all ease-in-out;
}
.form-control .input-field-box .select-field .selected-options {
  border-radius: 0.25rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.25rem;
  overflow-x: auto;
  scrollbar-width: none;
}
.form-control .input-field-box .select-field .selected-options .selected-option-text {
  background-color: var(--primaryMain-300);
  border-radius: 0.25rem;
  color: var(--black-1000);
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.4;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.5rem;
  transition: 200ms all ease-in-out;
}
.form-control .input-field-box .select-field .selected-options .selected-option-text .dial-code-text {
  white-space: nowrap;
}
.form-control .input-field-box .select-field .selected-options .selected-option-text svg {
  width: 1.25rem;
  height: 1.25rem;
  fill: var(--black-1000);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  transition: 200ms all ease-in-out;
}
.form-control .input-field-box .select-field .selected-options .selected-option-text img {
  width: 1.25rem;
  height: 1.25rem;
  object-fit: contain;
  object-position: center;
  transition: 200ms all ease-in-out;
}
.form-control .input-field-box .select-field .selected-options .selected-option-text-single {
  width: 100%;
  color: var(--black-1000);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.4;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.form-control .input-field-box .select-field .selected-options .selected-option-text-single .dial-code-text {
  white-space: nowrap;
}
.form-control .input-field-box .select-field .selected-options .selected-option-text-single svg {
  width: 1.25rem;
  height: 1.25rem;
  fill: var(--black-1000);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  transition: 200ms all ease-in-out;
}
.form-control .input-field-box .select-field .selected-options .selected-option-text-single img {
  width: 1.25rem;
  height: 1.25rem;
  object-fit: contain;
  object-position: center;
  transition: 200ms all ease-in-out;
}
.form-control .input-field-box .select-field .dropdown-arrow {
  width: fit-content;
  background-color: transparent;
  border: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-left: auto;
  transition: 200ms all ease-in-out;
}
.form-control .input-field-box .select-field .dropdown-arrow svg {
  width: 0.75rem;
  height: 0.75rem;
  fill: var(--black-1000);
  transition: 200ms all ease-in-out;
}
.form-control .input-field-box .select-field.select-field-open .dropdown-arrow svg {
  fill: var(--black-1000);
}
.form-control .input-field-box .password-hide-show-btn {
  width: fit-content;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  position: absolute;
  top: 50%;
  right: 0.75rem;
  transform: translateY(-50%);
  transition: 200ms all ease-in-out;
}
.form-control .input-field-box .password-hide-show-btn svg {
  width: 1.25rem;
  height: 1.25rem;
  fill: var(--black-1000);
  transition: 200ms all ease-in-out;
}
.form-control .input-field-box .start-icon,
.form-control .input-field-box .end-icon {
  width: 1.25rem;
  height: 1.25rem;
  fill: var(--black-1000);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  transition: 200ms all ease-in-out;
}
.form-control .input-field-box img.start-icon,
.form-control .input-field-box img.end-icon {
  width: 1.25rem;
  height: 1.25rem;
  object-fit: contain;
  object-position: center;
  transition: 200ms all ease-in-out;
}
.form-control .input-field-box .start-icon {
  left: 0.75rem;
}
.form-control .input-field-box .end-icon {
  right: 0.75rem;
}
.form-control .input-field-box:has(.start-icon) .input-field,
.form-control .input-field-box:has(.start-icon) .textarea-field,
.form-control .input-field-box:has(.start-icon) .select-field {
  padding-left: 2.75rem;
}
.form-control .input-field-box:has(.end-icon) .input-field,
.form-control .input-field-box:has(.end-icon) .textarea-field,
.form-control .input-field-box:has(.end-icon) .select-field {
  padding-right: 2.75rem;
}
.form-control .dropdown-menu {
  width: 100%;
  background-color: var(--white-1000);
  border-radius: 1rem;
  box-shadow: 0px 0px 20px var(--black-250);
  padding: 0.5rem;
  z-index: 1;
  margin: 0.25rem 0;
  position: absolute;
  transition: 200ms all ease-in-out;
}
.form-control .dropdown-menu.dropdown-bottom {
  top: 100%;
  transform-origin: top !important;
  transition: 200ms all ease-in-out;
}
.form-control .dropdown-menu.dropdown-top {
  bottom: 100%;
  transform-origin: bottom !important;
  transition: 200ms all ease-in-out;
}
.form-control .dropdown-menu .dropdown-menu-inner {
  width: 100%;
  max-height: 16rem;
  border-radius: 0.5rem;
  overflow-y: auto;
  transition: 200ms all ease-in-out;
}
.form-control .dropdown-menu .dropdown-menu-inner .dropdown-item {
  border-radius: 0.5rem;
  color: var(--black-1000);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.4;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  padding: 0.5rem 0.5rem 0.5rem 0.75rem;
  transition: 200ms all ease-in-out;
}
.form-control .dropdown-menu .dropdown-menu-inner .dropdown-item .icon-box {
  width: 1rem;
  min-width: 1rem;
  height: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.form-control .dropdown-menu .dropdown-menu-inner .dropdown-item .icon-box svg {
  width: 100%;
  height: 100%;
  fill: var(--black-1000);
  transition: 200ms all ease-in-out;
}
.form-control .dropdown-menu .dropdown-menu-inner .dropdown-item .icon-box img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  transition: 200ms all ease-in-out;
}
.form-control .dropdown-menu .dropdown-menu-inner .dropdown-item .text {
  width: 100%;
  color: var(--black-1000);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.4;
}
.form-control .dropdown-menu .dropdown-menu-inner .dropdown-item .text:has(.dial-code-text) {
  display: flex;
  align-items: baseline;
  gap: 0.25rem;
}
.form-control .dropdown-menu .dropdown-menu-inner .dropdown-item .text .dial-code-text,
.form-control .dropdown-menu .dropdown-menu-inner .dropdown-item .text .label-text {
  display: block;
}
.form-control .dropdown-menu .dropdown-menu-inner .dropdown-item .text .dial-code-text {
  white-space: nowrap;
}
.form-control .dropdown-menu .dropdown-menu-inner .dropdown-item .text .dial-code-text + .label-text {
  font-size: 0.75rem;
}
.form-control .dropdown-menu .dropdown-menu-inner .dropdown-item:not(:last-child) {
  margin-bottom: 0.125rem;
}
.form-control .dropdown-menu .dropdown-menu-inner .dropdown-item .deselect-button {
  width: 1rem;
  min-width: 1rem;
  height: 1rem;
  border-radius: 50%;
  display: none;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  transition: 200ms all ease-in-out;
}
.form-control .dropdown-menu .dropdown-menu-inner .dropdown-item .deselect-button svg {
  width: 100%;
  height: 100%;
  fill: var(--dangerMain-1000);
  transition: 200ms all ease-in-out;
}
.form-control .dropdown-menu .dropdown-menu-inner .dropdown-item:hover:not(.selected) {
  background-color: var(--primaryMain-1000);
  color: var(--white-1000);
}
.form-control .dropdown-menu .dropdown-menu-inner .dropdown-item:hover:not(.selected) .icon-box svg {
  fill: var(--white-1000);
}
.form-control .dropdown-menu .dropdown-menu-inner .dropdown-item:hover:not(.selected) .text,
.form-control .dropdown-menu .dropdown-menu-inner .dropdown-item:hover:not(.selected) .dial-code-text {
  color: var(--white-1000);
}
.form-control .dropdown-menu .dropdown-menu-inner .dropdown-item.selected {
  background-color: var(--primaryMain-200);
}
.form-control .dropdown-menu .dropdown-menu-inner .dropdown-item.selected .deselect-button {
  display: flex;
}
.form-control .dropdown-menu .deselect-all-btn {
  width: 100%;
  background-color: var(--dangerMain-1000);
  border: 0;
  border-radius: 0.5rem;
  color: var(--white-1000);
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.4;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  padding: 0.625rem 1rem;
  margin-top: 0.5rem;
  transition: 200ms all ease-in-out;
}
.form-control .dropdown-menu .deselect-all-btn svg {
  width: 1.25rem;
  height: 1.25rem;
  fill: var(--white-1000);
  transition: 200ms all ease-in-out;
}
.form-control .helper-text {
  color: var(--black-1000);
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.4;
  display: block;
  margin-top: 0.25rem;
}
.form-control .error-text {
  color: var(--dangerMain-1000);
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.4;
  display: block;
  margin-top: 0.25rem;
}
.form-control:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
@media screen and (max-width: 991.98px) {
  .form-control {
    margin-bottom: 1rem;
  }
  .form-control .input-label-text {
    font-size: 0.875rem;
    margin-bottom: 0.25rem;
  }
  .form-control .input-label-text .required-star {
    font-size: 1rem;
  }
  .form-control .input-field-box .input-field,
  .form-control .input-field-box .textarea-field,
  .form-control .input-field-box .select-field {
    font-size: 0.875rem;
    padding: 0.625rem 0.75rem;
  }
  .form-control .input-field-box .input-field::placeholder,
  .form-control .input-field-box .textarea-field::placeholder,
  .form-control .input-field-box .select-field::placeholder {
    font-size: 0.875rem;
  }
  .form-control .input-field-box .input-field::-ms-input-placeholder,
  .form-control .input-field-box .textarea-field::-ms-input-placeholder,
  .form-control .input-field-box .select-field::-ms-input-placeholder {
    font-size: 0.875rem;
  }
  .form-control .helper-text,
  .form-control .error-text {
    font-size: 0.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Common_UI_Kit/CustomInput/CustomInputStyle.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AACF;AACE;EACE,wBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AACJ;AACI;EACE,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,qBAAA;AACN;AAGE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AADJ;AAGI;;;EAGE,WAAA;EACA,6BAAA;EACA,SAAA;EACA,0CAAA;EACA,gCAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,iCAAA;AADN;AAGM;;;EACE,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;AACR;AAEM;;;EACE,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;AAER;AAEI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,iCAAA;AAAN;AAEM;EACE,sBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;AAAR;AAEQ;EACE,wCAAA;EACA,sBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,iCAAA;AAAV;AAEU;EACE,mBAAA;AAAZ;AAGU;EACE,cAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,iCAAA;AADZ;AAIU;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;AAFZ;AAMQ;EACE,WAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAJV;AAMU;EACE,mBAAA;AAJZ;AAOU;EACE,cAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,iCAAA;AALZ;AAQU;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;AANZ;AAWM;EACE,kBAAA;EACA,6BAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;AATR;AAWQ;EACE,cAAA;EACA,eAAA;EACA,uBAAA;EACA,iCAAA;AATV;AAeU;EACE,uBAAA;AAbZ;AAmBI;EACE,kBAAA;EACA,6BAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,cAAA;EACA,2BAAA;EACA,iCAAA;AAjBN;AAmBM;EACE,cAAA;EACA,eAAA;EACA,uBAAA;EACA,iCAAA;AAjBR;AAqBI;;EAEE,cAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,iCAAA;AAnBN;AAsBI;;EAEE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;AApBN;AAuBI;EACE,aAAA;AArBN;AAwBI;EACE,cAAA;AAtBN;AA0BM;;;EAGE,qBAAA;AAxBR;AA6BM;;;EAGE,sBAAA;AA3BR;AAgCE;EACE,WAAA;EACA,mCAAA;EACA,mBAAA;EACA,yCAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,iCAAA;AA9BJ;AAgCI;EACE,SAAA;EACA,gCAAA;EACA,iCAAA;AA9BN;AAiCI;EACE,YAAA;EACA,mCAAA;EACA,iCAAA;AA/BN;AAkCI;EACE,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,iCAAA;AAhCN;AAkCM;EACE,qBAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,qCAAA;EACA,iCAAA;AAhCR;AAkCQ;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAhCV;AAkCU;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,iCAAA;AAhCZ;AAmCU;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;AAjCZ;AAqCQ;EACE,WAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAnCV;AAqCU;EACE,aAAA;EACA,qBAAA;EACA,YAAA;AAnCZ;AAsCU;;EAEE,cAAA;AApCZ;AAuCU;EACE,mBAAA;AArCZ;AAuCY;EACE,kBAAA;AArCd;AA2CQ;EACE,uBAAA;AAzCV;AA4CQ;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iCAAA;AA1CV;AA4CU;EACE,WAAA;EACA,YAAA;EACA,4BAAA;EACA,iCAAA;AA1CZ;AA8CQ;EACE,yCAAA;EACA,wBAAA;AA5CV;AA+CY;EACE,uBAAA;AA7Cd;AAiDU;;EAEE,wBAAA;AA/CZ;AAmDQ;EACE,wCAAA;AAjDV;AAmDU;EACE,aAAA;AAjDZ;AAuDI;EACE,WAAA;EACA,wCAAA;EACA,SAAA;EACA,qBAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;AArDN;AAuDM;EACE,cAAA;EACA,eAAA;EACA,uBAAA;EACA,iCAAA;AArDR;AA0DE;EACE,wBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAxDJ;AA2DE;EACE,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAzDJ;AAkEE;EACE,YAAA;EACA,mBAAA;AAhEJ;AAmEE;EA1bF;IA2bI,mBAAA;EAhEF;EAkEE;IACE,mBAAA;IACA,sBAAA;EAhEJ;EAkEI;IACE,eAAA;EAhEN;EAqEI;;;IAGE,mBAAA;IACA,yBAAA;EAnEN;EAqEM;;;IACE,mBAAA;EAjER;EAoEM;;;IACE,mBAAA;EAhER;EAqEE;;IAEE,kBAAA;EAnEJ;AACF","sourcesContent":[".form-control {\n  width: 100%;\n  margin-bottom: 1.5rem;\n  position: relative;\n  transition: 200ms all ease-in-out;\n\n  .input-label-text {\n    color: var(--black-1000);\n    font-size: 1.125rem;\n    font-weight: 500;\n    line-height: 1.4;\n    display: block;\n    margin-bottom: 0.5rem;\n\n    .required-star {\n      color: var(--dangerMain-1000);\n      font-size: 1.25rem;\n      font-weight: 700;\n      line-height: 1;\n      margin-left: 0.25rem;\n      display: inline-block;\n    }\n  }\n\n  .input-field-box {\n    display: flex;\n    align-items: center;\n    position: relative;\n\n    .input-field,\n    .textarea-field,\n    .select-field {\n      width: 100%;\n      background-color: transparent;\n      border: 0;\n      border-bottom: 2px solid var(--black-1000);\n      font-family: \"Inter\", sans-serif;\n      color: var(--black-1000);\n      font-size: 1rem;\n      font-weight: 400;\n      line-height: 1.4;\n      padding: 1rem 0.75rem;\n      transition: 200ms all ease-in-out;\n\n      &::placeholder {\n        color: var(--black-750);\n        font-size: 1rem;\n        font-weight: 400;\n        line-height: 1.4;\n        opacity: 1;\n      }\n\n      &::-ms-input-placeholder {\n        color: var(--black-750);\n        font-size: 1rem;\n        font-weight: 400;\n        line-height: 1.4;\n        opacity: 1;\n      }\n    }\n\n    .select-field {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      gap: 0.75rem;\n      cursor: pointer;\n      transition: 200ms all ease-in-out;\n\n      .selected-options {\n        border-radius: 0.25rem;\n        display: flex;\n        justify-content: flex-end;\n        align-items: center;\n        gap: 0.25rem;\n        overflow-x: auto;\n        scrollbar-width: none;\n\n        .selected-option-text {\n          background-color: var(--primaryMain-300);\n          border-radius: 0.25rem;\n          color: var(--black-1000);\n          font-size: 0.75rem;\n          font-weight: 400;\n          line-height: 1.4;\n          white-space: nowrap;\n          display: flex;\n          align-items: center;\n          gap: 0.5rem;\n          padding: 0.25rem 0.5rem;\n          transition: 200ms all ease-in-out;\n\n          .dial-code-text {\n            white-space: nowrap;\n          }\n\n          svg {\n            width: 1.25rem;\n            height: 1.25rem;\n            fill: var(--black-1000);\n            position: absolute;\n            top: 50%;\n            transform: translateY(-50%);\n            transition: 200ms all ease-in-out;\n          }\n\n          img {\n            width: 1.25rem;\n            height: 1.25rem;\n            object-fit: contain;\n            object-position: center;\n            transition: 200ms all ease-in-out;\n          }\n        }\n\n        .selected-option-text-single {\n          width: 100%;\n          color: var(--black-1000);\n          font-size: 1rem;\n          font-weight: 400;\n          line-height: 1.4;\n          display: flex;\n          align-items: center;\n          gap: 0.75rem;\n          \n          .dial-code-text {\n            white-space: nowrap;\n          }\n\n          svg {\n            width: 1.25rem;\n            height: 1.25rem;\n            fill: var(--black-1000);\n            position: absolute;\n            top: 50%;\n            transform: translateY(-50%);\n            transition: 200ms all ease-in-out;\n          }\n\n          img {\n            width: 1.25rem;\n            height: 1.25rem;\n            object-fit: contain;\n            object-position: center;\n            transition: 200ms all ease-in-out;\n          }\n        }\n      }\n\n      .dropdown-arrow {\n        width: fit-content;\n        background-color: transparent;\n        border: 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        cursor: pointer;\n        margin-left: auto;\n        transition: 200ms all ease-in-out;\n\n        svg {\n          width: 0.75rem;\n          height: 0.75rem;\n          fill: var(--black-1000);\n          transition: 200ms all ease-in-out;\n        }\n      }\n\n      &.select-field-open {\n        .dropdown-arrow {\n          svg {\n            fill: var(--black-1000);\n          }\n        }\n      }\n    }\n\n    .password-hide-show-btn {\n      width: fit-content;\n      background-color: transparent;\n      border: 0;\n      cursor: pointer;\n      position: absolute;\n      top: 50%;\n      right: 0.75rem;\n      transform: translateY(-50%);\n      transition: 200ms all ease-in-out;\n\n      svg {\n        width: 1.25rem;\n        height: 1.25rem;\n        fill: var(--black-1000);\n        transition: 200ms all ease-in-out;\n      }\n    }\n\n    .start-icon,\n    .end-icon {\n      width: 1.25rem;\n      height: 1.25rem;\n      fill: var(--black-1000);\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      transition: 200ms all ease-in-out;\n    }\n\n    img.start-icon,\n    img.end-icon {\n      width: 1.25rem;\n      height: 1.25rem;\n      object-fit: contain;\n      object-position: center;\n      transition: 200ms all ease-in-out;\n    }\n\n    .start-icon {\n      left: 0.75rem;\n    }\n\n    .end-icon {\n      right: 0.75rem;\n    }\n\n    &:has(.start-icon) {\n      .input-field,\n      .textarea-field,\n      .select-field {\n        padding-left: 2.75rem;\n      }\n    }\n\n    &:has(.end-icon) {\n      .input-field,\n      .textarea-field,\n      .select-field {\n        padding-right: 2.75rem;\n      }\n    }\n  }\n\n  .dropdown-menu {\n    width: 100%;\n    background-color: var(--white-1000);\n    border-radius: 1rem;\n    box-shadow: 0px 0px 20px var(--black-250);\n    padding: 0.5rem;\n    z-index: 1;\n    margin: 0.25rem 0;\n    position: absolute;\n    transition: 200ms all ease-in-out;\n\n    &.dropdown-bottom {\n      top: 100%;\n      transform-origin: top !important;\n      transition: 200ms all ease-in-out;\n    }\n    \n    &.dropdown-top {\n      bottom: 100%;\n      transform-origin: bottom !important;\n      transition: 200ms all ease-in-out;\n    }\n\n    .dropdown-menu-inner {\n      width: 100%;\n      max-height: 16rem;\n      border-radius: 0.5rem;\n      overflow-y: auto;\n      transition: 200ms all ease-in-out;\n\n      .dropdown-item {\n        border-radius: 0.5rem;\n        color: var(--black-1000);\n        font-size: 1rem;\n        font-weight: 400;\n        line-height: 1.4;\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n        gap: 0.75rem;\n        cursor: pointer;\n        padding: 0.5rem 0.5rem 0.5rem 0.75rem;\n        transition: 200ms all ease-in-out;\n\n        .icon-box {\n          width: 1rem;\n          min-width: 1rem;\n          height: 1rem;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n\n          svg {\n            width: 100%;\n            height: 100%;\n            fill: var(--black-1000);\n            transition: 200ms all ease-in-out;\n          }\n          \n          img {\n            width: 100%;\n            height: 100%;\n            object-fit: contain;\n            object-position: center;\n            transition: 200ms all ease-in-out;\n          }\n        }\n\n        .text {\n          width: 100%;\n          color: var(--black-1000);\n          font-size: 1rem;\n          font-weight: 400;\n          line-height: 1.4;\n          \n          &:has(.dial-code-text) {\n            display: flex;\n            align-items: baseline;\n            gap: 0.25rem;\n          }\n          \n          .dial-code-text,\n          .label-text {\n            display: block;\n          }\n            \n          .dial-code-text {\n            white-space: nowrap;\n\n            & + .label-text {\n              font-size: 0.75rem;\n            }\n          }\n        }\n\n  \n        &:not(:last-child) {\n          margin-bottom: 0.125rem;\n        }\n  \n        .deselect-button {\n          width: 1rem;\n          min-width: 1rem;\n          height: 1rem;\n          border-radius: 50%;\n          display: none;\n          justify-content: center;\n          align-items: center;\n          margin-left: auto;\n          transition: 200ms all ease-in-out;\n  \n          svg {\n            width: 100%;\n            height: 100%;\n            fill: var(--dangerMain-1000);\n            transition: 200ms all ease-in-out;\n          }\n        }\n  \n        &:hover:not(.selected) {\n          background-color: var(--primaryMain-1000);\n          color: var(--white-1000);\n\n          .icon-box {  \n            svg {\n              fill: var(--white-1000);\n            }\n          }\n\n          .text,\n          .dial-code-text {\n            color: var(--white-1000);\n          }\n        }\n  \n        &.selected {\n          background-color: var(--primaryMain-200);\n  \n          .deselect-button {\n            display: flex;\n          }\n        }\n      }\n    }\n\n    .deselect-all-btn {\n      width: 100%;\n      background-color: var(--dangerMain-1000);\n      border: 0;\n      border-radius: 0.5rem;\n      color: var(--white-1000);\n      font-size: 1rem;\n      font-weight: 500;\n      line-height: 1.4;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 0.5rem;\n      cursor: pointer;\n      padding: 0.625rem 1rem;\n      margin-top: 0.5rem;\n      transition: 200ms all ease-in-out;\n\n      svg {\n        width: 1.25rem;\n        height: 1.25rem;\n        fill: var(--white-1000);\n        transition: 200ms all ease-in-out;\n      }\n    }\n  }\n\n  .helper-text {\n    color: var(--black-1000);\n    font-size: 0.875rem;\n    font-weight: 500;\n    line-height: 1.4;\n    display: block;\n    margin-top: 0.25rem;\n  }\n\n  .error-text {\n    color: var(--dangerMain-1000);\n    font-size: 0.875rem;\n    font-weight: 500;\n    line-height: 1.4;\n    display: block;\n    margin-top: 0.25rem;\n  }\n\n  &:hover:not(:disabled) {\n  }\n\n  &:active:not(:disabled) {\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  @media screen and (max-width: 991.98px) {\n    margin-bottom: 1rem;\n\n    .input-label-text {\n      font-size: 0.875rem;\n      margin-bottom: 0.25rem;\n  \n      .required-star {\n        font-size: 1rem;\n      }\n    }\n\n    .input-field-box {  \n      .input-field,\n      .textarea-field,\n      .select-field {\n        font-size: 0.875rem;\n        padding: 0.625rem 0.75rem;\n  \n        &::placeholder {\n          font-size: 0.875rem;\n        }\n  \n        &::-ms-input-placeholder {\n          font-size: 0.875rem;\n        }\n      }\n    }\n\n    .helper-text,\n    .error-text {\n      font-size: 0.75rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
